import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, Container, Row, Col, Form, Modal, Badge } from 'react-bootstrap';
import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import $ from 'jquery'

import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import Dialog from '../Dialog';

function EnquiryView(props) {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [entityType, setEntityType] = useState(sessionStorage.entityType);

    const [userRight, setUserRight] = useState([]);

    const [onceRun, setOnceRun] = useState(false);
    const [reqData, setReqData] = useState([]);

    const [logData, setLogData] = useState([]);
    const [commentData, setCommentData] = useState([]);
    const [productData, setProductData] = useState([]);

    const [remark, setRemark] = useState([]);
    const [reqStatus, setReqStatus] = useState("");
    const [reqStatusDesc, setReqStatusDesc] = useState("");

    const [reqIsd, setReqIsd] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);
    const [reqIsdSelect, setReqIsdSelect] = useState([]);


    const [reqQuantity, setReqQuantity] = useState("");
    const [reqSellRate, setReqSellRate] = useState("");

    const [changeLocation, setChangeLocation] = useState(false);

    const [reqBran, setReqBran] = useState("0");
    const [ddReqBranOptions, setDdReqBranOptions] = useState([]);
    const [reqBranSelect, setReqBranSelect] = useState([]);

    const [reqProduct, setReqProduct] = useState("CN");
    const [ddReqProductOptions, setDdReqProductOptions] = useState([]);

    const [reqDate, setReqDate] = useState(new Date());
    const [reqCoverRate, setReqCoverRate] = useState('');

    const [docListDataSI, setDocListDataSI] = useState([]);
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);
    const [alreadyProcessed, setAlreadyProcessed] = useState(false)
    const [aPvalue, setAPvalue] = useState("")
    const [alrdPrcdRight, setAlrdPrcdRight] = useState();

    var msg = [], i = 0;


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            setOnceRun(true);
            Common.callApi(Common.apiRight, [sid, 'all', 'ENQUIRYLIST'], function (result) {
                let resp = JSON.parse(result);
                setUserRight(resp);
                if (resp.query === "1") {
                    setDdReqProductOptions(
                        [
                            { "value": "CN", "name": "CN" },
                            { "value": "CARD", "name": "CARD" }]
                    );
                    Common.callApi(Common.apiIsd, [sid, 'ddlistjsonselect'], function (result) {
                        setDdReqIsdOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiUser, [sid, 'branchallselect'], function (result) {
                        let resp = JSON.parse(result);
                        setDdReqBranOptions(resp);
                    });
                    getDetails();
                    if (resp.edit === "1") {
                        Common.callApi(Common.apiRight, [sid, 'all', 'ALREADYPROCESSEDMARKED'], function (result) {
                            setAlrdPrcdRight(JSON.parse(result))
                        })
                    }
                }
                else {
                    navigate('/'); // no query right
                }
            });

        }
    });


    function getDetails() {
        Common.callApi(Common.apiEnquiry, [sid, 'detail', props.srno], function (result) {
            let resp = JSON.parse(result);
            setReqData(resp.detail);
            setLogData(resp.log);
            setCommentData(resp.comment);
            setProductData(resp.product);
            setReqStatus(resp.detail.enq_statuscode);
            setReqStatusDesc(resp.detail.enq_status);
            //setReqIsd(resp.detail.enq_isd);
            //setReqQuantity(resp.detail.enq_quantity);
            //setReqSellRate(resp.detail.enq_sellrate);
            //setReqIsdSelect({ 'label': resp.detail.enq_isdname, 'value': resp.detail.enq_isd });
            //setReqCoverRate(0);
            //setReqDate(new Date());
        });
        Common.callApi(Common.apiEnquiry, [sid, 'getswiftinvoice', props.srno], function (result) {
            setDocListDataSI(JSON.parse(result));
        });
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiEnquiry, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                getDetails();
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnUpdateClick() {

        if (!reqDate || !reqQuantity || !reqSellRate || !reqIsd || !reqCoverRate) {
            setMsgBox(true);
            setMsgText('Please select date');

            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!reqIsd ? 'ISD' : '');
            msg[i++] = (!reqQuantity ? 'Quantity' : '');
            msg[i++] = (!reqSellRate ? 'Sale Rate' : '');
            msg[i++] = (!reqDate ? 'Date' : '');
            msg[i++] = (!reqCoverRate ? 'Cover Rate' : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        else {
            var object1 = {
                srno: props.srno,
                status: reqStatus,
                isd: reqIsd,
                qty: reqQuantity,
                rate: reqSellRate,
                product: reqProduct,
                date: Common.dateYMD(reqDate),
                coverRate: reqCoverRate
            }
            Common.callApi(Common.apiEnquiry, [sid, 'updateenquiry', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                if (resp.err === "") {
                    getDetails();
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    setReqCoverRate('');
                    setReqDate(new Date());
                    setReqQuantity('');
                    setReqSellRate('');
                    setReqProduct('TT');
                    setReqIsd(0);
                    setReqIsdSelect([]);

                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                setRefreshCounter(refreshCounter + 1);
            });
        }


    }

    function handleReqIsdOptions(v) {
        setReqIsdSelect(v);
        setReqIsd(v.value);
    }

    function handleReqBranchOptions(v) {
        setReqBranSelect(v);
        setReqBran(v.value);
    }

    function btnChangeLocation() {
        var object1 = {
            srno: props.srno,
            loc: reqBran
        }
        Common.callApi(Common.apiEnquiry, [sid, 'changeenquirylocation', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setChangeLocation(false);
                getDetails();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function btnDeleteProductClick(lineno) {
        var object1 = {
            srno: props.srno,
            lineno: lineno
        }
        Common.callApi(Common.apiEnquiry, [sid, 'deleteproduct', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                getDetails();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function changeHeaderStatus(newStatus) {
        var object1 = {
            srno: props.srno,
            status: newStatus
        }
        Common.callApi(Common.apiEnquiry, [sid, 'changestatus', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setReqStatus(resp.status);
                switch (resp.status) {
                    case 'E':
                        setReqStatusDesc("Enquiry");
                        break;
                    case 'C':
                        setReqStatusDesc("Engaged");
                        break;
                    case 'I':
                        setReqStatusDesc("InProcess");
                        break;
                    case 'P':
                        setReqStatusDesc("Processed");
                        break;
                    case 'R':
                        setReqStatusDesc("Rejected");
                        break;
                    case 'N':
                        setReqStatusDesc("Not Interested");
                        break;
                }
                setMsgText(resp.msg);
                setMsgBox(true);
                setRefreshCounter(refreshCounter + 1);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
                setRefreshCounter(refreshCounter + 1);
            }
        });
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function alreadyProcessedHandler() {
        console.log(reqData, "details")
        $('.loader').show();
        const obj = {
            refno: aPvalue,
            enqSrno: reqData.enq_srno,
        }
        Common.callDocumentViewApi(Common.apiEnquiry, [sid, 'markalreadyprocessed', JSON.stringify(obj)], function (result) {
            let resp = JSON.parse(result);
            $('.loader').hide();
            setMsgText(resp.msg);
            setMsgBox(true);
            if (resp.status) {
                // setAldrdPrcdStatus(true);
                setAlreadyProcessed(false);
                getDetails();
            }
        }
        );


    }

    return (
        <>

            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-top' >
                <Col xs={12}>
                    Status : <b>{reqStatus}&nbsp;{reqStatusDesc}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                    {
                        userRight.edit === "1" ? <>
                            {
                                reqStatus === "E" ? <>
                                    &nbsp;<Badge className="handCursor" bg="primary" onClick={(e) => changeHeaderStatus('C')}>Mark Engaged</Badge>&nbsp;

                                    <Badge className="handCursor" bg="danger" onClick={(e) => changeHeaderStatus('N')}>Mark Not Interested</Badge>&nbsp;
                                </> : null
                            }
                            {
                                reqStatus === "C" ? <>
                                    <Badge className="handCursor" bg="success" onClick={(e) => changeHeaderStatus('P')}>Mark Processed</Badge>&nbsp;
                                    <Badge className="handCursor" bg="danger" onClick={(e) => changeHeaderStatus('R')}>Mark Rejected</Badge>&nbsp;
                                </> : null
                            }
                            {
                                reqStatus === "EEEE" ? <>
                                    <Badge className="handCursor" bg="danger" onClick={(e) => changeHeaderStatus('I')}>Mark InProcess</Badge>&nbsp;
                                </> : null
                            }
                            {
                                (alrdPrcdRight?.query && reqData?.enq_status != 'Completed') ? <Badge className="handCursor" bg="primary" maxLength={50}
                                    onClick={(e) => setAlreadyProcessed(true)}>Already Processed</Badge> : null
                            }
                        </> : null
                    }

                </Col>
            </Row>
            {alreadyProcessed &&
                <Row style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Col>
                        <Form.Control type="text" value={aPvalue} onChange={(e) => { setAPvalue(e.target.value) }} autoComplete="off" />
                    </Col>
                    <Col>
                        <Form.Group >
                            <Button variant="outline-success" size="sm" onClick={alreadyProcessedHandler} >Add/Update</Button>&nbsp;
                            <Button variant="outline-success" size="sm" onClick={(e) => setAlreadyProcessed(false)} >Cancel</Button>&nbsp;
                        </Form.Group>
                    </Col>
                </Row>
            }
            <Row>
                <Col>Type : <b>{reqData.enq_requesttype}</b></Col>
                <Col>Partner : <b>{reqData.agn_entity_name}&nbsp;{reqData.mel_location}</b></Col>
                <Col>Unique No : <b>{reqData.enq_loanacctno}</b></Col>
            </Row>
            <Row>
                <Col>Sr No : <b>{reqData.enq_srno}</b></Col>
                <Col>
                    Branch : <b>{reqData.enq_branch} {reqData.br_entity_name}</b> {
                        userRight.edit === "1" && changeLocation === false ? <>
                            <Badge className="handCursor" bg="danger" onClick={(e) => setChangeLocation(true)}>Change</Badge>
                        </> : null
                    }
                </Col>
                <Col>Reference : <b>{reqData.enq_refno}</b></Col>
            </Row>
            {
                userRight.edit === "1" && changeLocation ? <>
                    <Row >
                        <Col>
                            &nbsp;
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label>Location</Form.Label>
                                <Select
                                    value={reqBranSelect}
                                    onChange={handleReqBranchOptions}
                                    options={ddReqBranOptions}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnChangeLocation()} >Add/Update</Button>&nbsp;
                                <Button variant="outline-success" size="sm" onClick={(e) => setChangeLocation(false)} >Cancel</Button>&nbsp;
                            </Form.Group>
                        </Col>
                    </Row >
                    <Row >
                        <Col>
                            &nbsp;
                        </Col>
                    </Row >

                </> : null
            }
            <Row>
                <Col>ISD : <b>{reqData.enq_isd}</b></Col>
                <Col>Quantity : <b>{reqData.enq_quantity}</b></Col>
                <Col>Sale Rate : <b>{reqData.enq_sellrate}</b></Col>
            </Row>
            <Row>
                <Col>Name : <b>{reqData.enq_name}</b></Col>
                <Col>Mobile : <b>{reqData.enq_mobile}</b></Col>
                <Col>Email : <b>{reqData.enq_emailaddress}</b></Col>
            </Row >
            <Row>
                <Col>Address : <b>{reqData.enq_addfull}</b></Col>
                <Col>Pincode : <b>{reqData.enq_pincode}</b></Col>
                <Col>Remit Country : <b>{reqData.mc_cnt_name}</b></Col>
            </Row>
            <Row>
                <Col>Disbursement Date : <b>{reqData.disbursementdate}</b></Col>
                <Col>Disbursement Amount : <b>{reqData.enq_disbursementamt}</b></Col>
                <Col>Forex Amount : <b>{reqData.enq_forexamt}</b></Col>

            </Row>
            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>

            {
                userRight.edit === "1" ?
                    <>

                        {
                            reqData.enq_statuscode === "E" || reqData.enq_statuscode === "C" || reqData.enq_statuscode === "D" ?
                                <>
                                    <Row>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label>Product</Form.Label>
                                                <Form.Select
                                                    value={reqProduct}
                                                    onChange={(e) => setReqProduct(e.target.value)}  >
                                                    {ddReqProductOptions.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Currency</Form.Label>
                                                <Select
                                                    value={reqIsdSelect}
                                                    onChange={handleReqIsdOptions}
                                                    options={ddReqIsdOptions}

                                                />

                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Quantity</Form.Label>
                                                <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                                    value={reqQuantity} autoComplete="off"

                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>Sale Rate</Form.Label>
                                                <Form.Control type="text" placeholder="Sale Rate" maxLength={10} autoComplete="off"
                                                    value={reqSellRate}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setReqSellRate)}

                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {
                                        reqProduct === "CN" || reqProduct === "CARD" ? <>
                                            <Row>
                                                <Col>
                                                    <Form.Group >
                                                        <Form.Label>Date</Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={reqDate}
                                                            onChange={(date) => setReqDate(date)}
                                                            isClearable
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            placeholder="Date"
                                                            customInput={
                                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>

                                                    <Form.Group >
                                                        <Form.Label>Cost Rate</Form.Label>
                                                        <Form.Control type="text" placeholder="Cost Rate" maxLength={10}
                                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqCoverRate)}
                                                            value={reqCoverRate} autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col>&nbsp;</Col>
                                                <Col>&nbsp;</Col>
                                            </Row>
                                        </> : null
                                    }
                                    <Row>
                                        <Col>
                                            <Form.Group >
                                                <Form.Label>&nbsp;</Form.Label><br></br>
                                                <Button variant="outline-danger" size="sm" onClick={(e) => btnUpdateClick()} >Add</Button>&nbsp;
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </> :
                                <>
                                </>

                        }
                        {
                            /*
                                <Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                value={reqStatus}
                                                onChange={(e) => setReqStatus(e.target.value)}
                                            >
                                                <option value="N">New</option>
                                                <option value="I">In Process</option>
                                                <option value="R">Not Executed</option>
                                                <option value="D">Completed</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>&nbsp;</Col><Col>&nbsp;</Col><Col>&nbsp;</Col>
                                </Row>
                            */
                        }

                        <Row className='border-bottom'>
                            <Col>&nbsp;</Col>
                        </Row>
                    </>
                    : <>
                    </>
            }

            <Row>
                <Col>
                    <h5>Product Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                {
                                    userRight.edit === "1" ?
                                        <td>&nbsp;</td>
                                        : null
                                }
                                <td>Product</td>
                                <td>ISD</td>
                                <td>Quanity</td>
                                <td>Rate</td>
                                <td>Date</td>
                                {
                                    entityType === "B" ? <>
                                        <td>Cover Rate</td>
                                    </> : null
                                }
                                <td>Ref No</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                productData.length > 0 ? <>
                                    {
                                        productData.map((res) =>
                                            <tr key={res.eprod_lineno} >

                                                {
                                                    userRight.edit === "1" ? <>
                                                        <td>
                                                            {
                                                                (res.eprod_product === "CN" || res.eprod_product === "CARD") ? <>
                                                                    <div className="colorThemeBlue">
                                                                        <span className="handCursor" onClick={(e) => btnDeleteProductClick(res.eprod_lineno)}>
                                                                            <FontAwesomeIcon icon={faTrashAlt} />
                                                                        </span>
                                                                    </div>
                                                                </> : null
                                                            }
                                                        </td>
                                                    </> : null
                                                }
                                                <td>{res.eprod_product}</td>
                                                <td>{res.eprod_isd}</td>
                                                <td>{res.eprod_quantity}</td>
                                                <td>{res.eprod_sellrate}</td>
                                                <td>{res.formattedDate}</td>
                                                {
                                                    entityType === "B" ? <>
                                                        <td>{res.eprod_coverrate}</td>
                                                    </> : null
                                                }


                                                <td>{res.req_refno}</td>
                                            </tr>
                                        )
                                    }
                                </> : null
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    <h5>Swift</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>

                                <td>Type</td>
                                <td>Remark</td>
                                <td>File Name</td>
                                <td>Password</td>
                                <td>&nbsp;</td>
                            </tr>
                        </thead>
                        <tbody>
                            {docListDataSI.map((res) =>
                                <tr key={res.srno}>

                                    <td className='divHide'>{res.doc_srno}</td>
                                    <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                    <td>{res.doc_remark}</td>
                                    <td>{res.doc_filename}</td>
                                    <td>{res.cover_bank_pass}</td>
                                    <td>
                                        <div className="colorThemeBlue">
                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                <FontAwesomeIcon icon={faEye} />
                                            </span>&nbsp;
                                            <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                <FontAwesomeIcon icon={faFileDownload} />
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col xs={6}>
                    <Form.Group >
                        <Form.Label>Comment</Form.Label>
                        <Form.Control type="text" placeholder="Comment" maxLength={100}
                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                            value={remark} autoComplete="off" />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group >
                        <Form.Label>&nbsp;</Form.Label><br></br>
                        <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h5>Comment Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <td>Timestamp</td>
                                <td>User</td>
                                <td>Comment</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                commentData.length > 0 ? <>
                                    {
                                        commentData.map((res) =>
                                            <tr key={res.ecmnt_lineno}>
                                                <td>{res.ecmnt_createdatstamp}</td>
                                                <td>{res.um_username}</td>
                                                <td>{res.ecmnt_desc}</td>
                                            </tr>
                                        )
                                    }
                                </> : null
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h5>Log Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                logData.length > 0 ?
                                    <>
                                        {
                                            logData.map((res) =>
                                                <tr key={res.enqlog_lineno}>
                                                    <td>{res.enqlog_logtimestamp}</td>
                                                    <td>{res.um_username}</td>
                                                    <td>{res.enqlog_rmk}</td>
                                                </tr>
                                            )
                                        }
                                    </> : <></>
                            }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                </Modal.Body>
            </Modal>
            <Row><Col>&nbsp;</Col></Row>
            <Row><Col>&nbsp;</Col></Row>
            <span className="corner-span">{refreshCounter}</span>
        </>
    )
}
export default EnquiryView;